import { TAppealStatus } from 'feature/lkmAppeals/types'
import { FC, SyntheticEvent } from 'react'
import { Tabs } from '@mui/material'
import { Tab } from 'ui'

interface LkmAppealsTabsProps {
  changeStatus: (event: SyntheticEvent, newValue: TAppealStatus) => void
  value: TAppealStatus
}

export const LkmAppealsTabs: FC<LkmAppealsTabsProps> = ({
  changeStatus,
  value,
}) => {
  return (
    <Tabs onChange={changeStatus} value={value}>
      <Tab label='Новые' value='new' data-testid='lkm-tab-new' />
      <Tab
        label='В работе'
        value='in_progress'
        data-testid='lkm-tab-progress'
      />
      <Tab
        label='Завершенные'
        value='completed'
        data-testid='lkm-tab-completed'
      />
    </Tabs>
  )
}
